import { signal } from "signlets";

import type { World } from "./world";

export const [world, setWorld] = signal<World | undefined>(undefined);
